import { render, staticRenderFns } from "./EncounterReferralModal.vue?vue&type=template&id=787c6cd4&"
import script from "./EncounterReferralModal.vue?vue&type=script&lang=js&"
export * from "./EncounterReferralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports